"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.versionToNumber = exports.ViewRect = exports.generateSpiralMatrix = void 0;
var spiral_1 = require("./spiral");
Object.defineProperty(exports, "generateSpiralMatrix", { enumerable: true, get: function () { return spiral_1.generateSpiralMatrix; } });
class ViewRect {
    x0;
    x1;
    z0;
    z1;
    constructor(cx, cz, viewDistance) {
        this.x0 = cx - viewDistance;
        this.x1 = cx + viewDistance;
        this.z0 = cz - viewDistance;
        this.z1 = cz + viewDistance;
    }
    contains(x, z) {
        return this.x0 <= x && x <= this.x1 && this.z0 <= z && z <= this.z1;
    }
}
exports.ViewRect = ViewRect;
const versionToNumber = (ver) => {
    const [x, y = '0', z = '0'] = ver.split('.');
    return +`${x.padStart(2, '0')}${(parseInt(y).toString().padStart(2, '0'))}${parseInt(z).toString().padStart(2, '0')}`;
};
exports.versionToNumber = versionToNumber;
